function polarToCartesian(centerPoint, radius, angleInDegrees) {
  const angleInRadians = (angleInDegrees - 90) * Math.PI / 180;
  return {
    x: centerPoint + radius * Math.cos(angleInRadians),
    y: centerPoint + radius * Math.sin(angleInRadians)
  };
}
function describeArcPath(diameterInPx, strokeWidthInPx, angleInDegrees) {
  const centerPoint = diameterInPx / 2;
  const radius = centerPoint - strokeWidthInPx / 2;
  const startAt = polarToCartesian(centerPoint, radius, angleInDegrees);
  const endAt = polarToCartesian(centerPoint, radius, 0);
  const largeArcFlag = angleInDegrees <= 180 ? "0" : "1";
  const d = [
    "M",
    startAt.x,
    startAt.y,
    "A",
    radius,
    radius,
    0,
    largeArcFlag,
    0,
    endAt.x,
    endAt.y
  ].join(" ");
  return d;
}

export { describeArcPath };
//# sourceMappingURL=svg.describe-arc-path.js.map
